module.exports = __webpack_public_path__ + "static/media/link.66775860.png";